import type { CustomCarouselProps } from "@/app/directories/shop/[clientSlug]/types";
import { getOrganizationAssetsForOrg } from "@frontend/lib/actions/config-actions";
import { CustomCarousel } from "./CustomCarousel";

export default async function CustomCarouselWrapper({
  props,
  style,
  params,
}: {
  props: CustomCarouselProps;
  style: string;
  params: { clientSlug: string; orgId: number };
}) {
  const organizationAssets = await getOrganizationAssetsForOrg(params.orgId);

  const secondaryBackgroundColor = organizationAssets?.secondaryBackgroundColor;

  return (
    <CustomCarousel
      items={props.items}
      style={style}
      imagePosition={props.imagePosition}
      secondaryBackgroundColor={secondaryBackgroundColor}
    />
  );
}
